import UserData from 'BrdData/UserData';
import { AppContentView } from 'Components/AppLayout';
import { SITE_PAGES } from 'Config';
import { DataManager } from 'Lib/data';
import AdminLanding from 'Pages/Admin/AdminLanding';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import UserDetails from './UserDetails';

let DM = new DataManager();

const UserDetailsPage = ({ userId, userObject, params, isMyAccountPage }) => {
  const navigate = useNavigate();
  let breadcrumbs = params?.id && [
    SITE_PAGES.MANAGE_USERS,
    {
      icon: SITE_PAGES.USER_DETAILS.icon,
      text: params.id,
    },
  ];

  useEffect(() => {
    DM.add(
      UserData.registerListener('RECORDS_DELETED', () =>
        navigate(SITE_PAGES.MANAGE_USERS.path),
      ),
      UserData,
    );
    return () => {
      DM.clear();
    };
  }, []);

  return isMyAccountPage ? (
    <AppContentView title='My Profile' hideBreadcrumbs>
      <UserDetails isMyAccountPage editable />
    </AppContentView>
  ) : (
    <AdminLanding title='Manage User' breadcrumbs={breadcrumbs}>
      <UserDetails
        params={params}
        userId={userId}
        userObject={userObject}
        editable
      />
    </AdminLanding>
  );
};

UserDetailsPage.propTypes = {
  userId: PropTypes.number,
  userObject: PropTypes.object,
  params: PropTypes.shape({ id: PropTypes.string }),
  isMyAccountPage: PropTypes.bool,
};

export default UserDetailsPage;
